/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner } from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner';
import {
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSONTyped,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSONTyped,
} from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner';
import type { MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner } from './MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner';
import {
    MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSON,
    MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped,
    MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerToJSON,
    MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerToJSONTyped,
} from './MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner';
import type { MatrixCarePatientDetailsDocumentsScreenerDocumentsInner } from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInner';
import {
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSONTyped,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerToJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerToJSONTyped,
} from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInner';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocuments
 */
export interface MatrixCarePatientDetailsDocuments {
    /**
     * 
     */
    generated_documents?: Array<MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner>;
    /**
     * 
     */
    screener_documents?: Array<MatrixCarePatientDetailsDocumentsScreenerDocumentsInner>;
    /**
     * 
     */
    additional_documents?: Array<CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner>;
}

/**
 * Check if a given object implements the MatrixCarePatientDetailsDocuments interface.
 */
export function instanceOfMatrixCarePatientDetailsDocuments(value: object): value is MatrixCarePatientDetailsDocuments {
    return true;
}

export function MatrixCarePatientDetailsDocumentsFromJSON(json: any): MatrixCarePatientDetailsDocuments {
    return MatrixCarePatientDetailsDocumentsFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocuments {
    if (json == null) {
        return json;
    }
    return {
        
        'generated_documents': json['generated_documents'] == null ? undefined : ((json['generated_documents'] as Array<any>).map(MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSON)),
        'screener_documents': json['screener_documents'] == null ? undefined : ((json['screener_documents'] as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSON)),
        'additional_documents': json['additional_documents'] == null ? undefined : ((json['additional_documents'] as Array<any>).map(CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSON)),
    };
}

export function MatrixCarePatientDetailsDocumentsToJSON(json: any): MatrixCarePatientDetailsDocuments {
    return MatrixCarePatientDetailsDocumentsToJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsToJSONTyped(value?: MatrixCarePatientDetailsDocuments | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generated_documents': value['generated_documents'] == null ? undefined : ((value['generated_documents'] as Array<any>).map(MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerToJSON)),
        'screener_documents': value['screener_documents'] == null ? undefined : ((value['screener_documents'] as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerToJSON)),
        'additional_documents': value['additional_documents'] == null ? undefined : ((value['additional_documents'] as Array<any>).map(CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSON)),
    };
}

